import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'rc-slider';

import { saveConfig, updateEfficiencyRange } from '../../FilterActions';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

class EfficiencyRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      range: [0, 100],
    };
  }

  componentDidMount() {
    this.setState({ range: this.props.range });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.range != this.props.range) {
      this.setState({ range: this.props.range });
    }
  }

  handleChange = (e) => {
    this.setState({ range: e });
  };

  handleAfterChange = (e) => {
    this.props.updateValue(e);
    this.props.saveConfig();
  };

  render() {
    return (
      <div style={{ padding: '30px 30px 20px 40px' }}>
        <Range
          min={0}
          max={100}
          defaultValue={[0, 100]}
          pushable={20}
          allowCross={true}
          value={this.state.range}
          onChange={this.handleChange}
          onAfterChange={this.handleAfterChange}
          tipFormatter={(value) => `${value}%`}
          tipProps={{ visible: true }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateValue: (range) => dispatch(updateEfficiencyRange(range)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    range: state.filters[chart].effRange,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(EfficiencyRange);
export { connected as EfficiencyRange };
